import './loginCustom.css';
import React, { useLayoutEffect, useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Auth from '../auth';
import { pxbLifeAppActions, PxbLifeAppState } from "../state/PxbLifeAppSlice";
import {
  CHALLENGE_RESEND_PAGE, CHALLENGE_VALIDATION_CALLBACK,
  CHALLENGE_VERIFY_PAGE, PXB_LIFE_APP_CHALLENGE_RESEND_PAGE_PATH,
  PXB_LIFE_APP_CHALLENGE_VERIFY_PAGE_PATH, SESSION_TEMPLATE
} from "../../../../shared/utils/constants";
import loginsvg from '../assets/svg/login.svg';
import { Link } from 'react-router-dom';
import { Backdrop, Box, Button, CircularProgress, InputLabel, TextField } from '@mui/material';
import styles from "./PxbLifeAppLogin.styles";

export const LoginCustom = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // App State
  const pxbLifeAppState: PxbLifeAppState = useSelector((state: any) => state.pxbLifeApp);

  // page loading
  const [isPageLoading, setPageLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(undefined);
  const [userErrorMessage, setUserErrorMessage] = useState(undefined);
  const [pwdErrorMessage, setPwdErrorMessage] = useState(undefined);
  const [userNametextfield, setUserNametextfield] = useState('');
  const [passwordtextfield, setPasswordtextfield] = useState('');
  const clearErrorMessage = () => {
    setErrorMessage(undefined)
  };
  useLayoutEffect(() => {
    document.title = 'Pruxpress Life - Login';
  }, []);

  const { state } = useLocation();
  // Parse the query params and update
  useEffect(() => {

    if (state !== null) {
      switch (state) {
        case "sessionTimeout":
          setErrorMessage("Error! We are sorry, Session has timed out. Please login again." as any);
          break;
        case "maxLimit":
          setErrorMessage("Error! We are sorry, you have exceeded the maximum number of attempts. Please login again." as any);
          break;
        case "maxOtpLocked":
          setErrorMessage("Error! Your OTP credential has been locked because of continuous incorrect attempts. Please click the Forgot Your Password? link to reset your password." as any);
          break;
        case "otpExpired":
          setErrorMessage("Error! Login failure, expired One Time Passcode. Please try again." as any);
          break;
        default:
          setErrorMessage("Error! We are sorry, Please login again." as any);
      }
    }
  }, [state])

  const handleLogin = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setPageLoading(true);
    clearErrorMessage();
    try {
      const formData = new FormData(event.currentTarget);
      const username: FormDataEntryValue | null = formData.get('username');
      const pw: FormDataEntryValue | null = formData.get('password');
      if (!username && !pw) {
        setUserErrorMessage("Error! The User ID field must be completed." as any);
        setPwdErrorMessage("Error! The password field must be completed." as any);
        setPageLoading(false);
        if (inputRef.current) {
          inputRef.current.focus();
        }
        return;
      } else if (!username) {
        setUserErrorMessage("Error! The User ID field must be completed." as any);
        setPwdErrorMessage(undefined);
        setPageLoading(false);
        if (inputRef.current) {
          inputRef.current.focus();
        }
        return;
      } else if (!pw) {
        setPwdErrorMessage("Error! The password field must be completed." as any);
        setUserErrorMessage(undefined);
        setPageLoading(false);
        if (pwdRef.current) {
          pwdRef.current.focus();
        }
        return;
      } else {
        setUserErrorMessage(undefined);
        setPwdErrorMessage(undefined);
      }

      // Authenticate API Call
      const response: any = await Auth.login(SESSION_TEMPLATE, pxbLifeAppState.appConfig.ou, username.toString(), pw.toString(), pxbLifeAppState.headers, pxbLifeAppState.appConfig.clientId);
      if (response.status === 401) {
        //70001 - user locked, 70002 - password expired, 70010 -invalid credentials
        if (response.data.errorCode === "70001" || response.data.title === "ACCOUNT LOCKED") {
          setErrorMessage("Error! We are sorry, you have exceeded the maximum number of log in attempts. Please click the Forgot Your Password? link to reset your password." as any);
          if (inputRef.current) {
            inputRef.current.focus();
          }
        } else if (response.data.errorCode === "70010") {
          setErrorMessage("Error! The user name or password you entered was not correct. Please try again." as any);
          if (inputRef.current) {
            inputRef.current.focus();
          }
        } else if (response.data.errorCode === "70013") {
          setErrorMessage("Error! Your OTP credential has been locked because of continuous incorrect attempts. Please click the Forgot Your Password? link to reset your password." as any);
          if (inputRef.current) {
            inputRef.current.focus();
          }
        } 
      } else if (response.status === 204) {
        return window.location.assign(pxbLifeAppState.appConfig.goto);
      } else {
        await dispatch(pxbLifeAppActions.updateAuthJourneyData(response.data));
        let callbacks = response.data.callbacks;
        let challengeValidationCallback = callbacks.find((c: any) => c.type === CHALLENGE_VALIDATION_CALLBACK);
        if (challengeValidationCallback) {
          /* Collect OTP */
          await dispatch(pxbLifeAppActions.updateDisplayPage(CHALLENGE_VERIFY_PAGE));
          navigate(`../${PXB_LIFE_APP_CHALLENGE_VERIFY_PAGE_PATH}`, { replace: true });
        } else {
          /* Select a contact */
          await dispatch(pxbLifeAppActions.updateDisplayPage(CHALLENGE_RESEND_PAGE));
          navigate(`../${PXB_LIFE_APP_CHALLENGE_RESEND_PAGE_PATH}`, { replace: true });
        }
      }
      // @ts-ignore
    } catch (error: Error) {
      setErrorMessage(error.message);
    }
    setUserNametextfield('');
    setPasswordtextfield('');
    setPageLoading(false);
  }

  const handleUserName = (event: any) => {
    setUserNametextfield(event.target.value);
  }
  const handlePasswordChange = (event: any) => {
    setPasswordtextfield(event.target.value);
  }
  const inputRef = useRef<HTMLInputElement>(null);
  const pwdRef = useRef<HTMLInputElement>(null);

  function getForgotlogincredentialsURL() {
    let urlLastPart = ".prudential.com/forgotlogincredentials";
    let urlFirstPart = "https://prudentialexpresslife";
    let urlMidPart = "";
    let gotoUrl = (window.location.search.split("=")[3]);
    let envBase = gotoUrl.split("-")[1];
	  let env = "";
	  if (envBase != undefined) {
		  env = envBase.split(".")[0];
	  }
    if (env === "") {
      //its PROD
      urlFirstPart = "https://prudentialexpresslife";
    } else {
      urlMidPart = "-" + env;
    }
    let url = urlFirstPart + urlMidPart + urlLastPart
    return url;
  }

  function forgotlogincredentialsLink() {
    window.location.href = getForgotlogincredentialsURL();
  }

  function registerNow() {
    window.location.href = getRegistrationURL();
  }

  function getRegistrationURL() {
    let urlLastPart = ".prudential.com/registerUser";
    let urlFirstPart = "https://prudentialexpresslife";
    let urlMidPart = "";
    let gotoUrl = (window.location.search.split("=")[3]);
    let envBase = gotoUrl.split("-")[1];
	  let env = "";
	  if (envBase != undefined) {
		  env = envBase.split(".")[0];
	  }
    if (env === "") {
      //its PROD
      urlFirstPart = "https://prudentialexpresslife";
    } else {
      urlMidPart = "-" + env;
    }
    let url = urlFirstPart + urlMidPart + urlLastPart
    return url;
  }

  return (
    <div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isPageLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div className="main-content">
        <div className="signin-form">
          <div className="form-left">
            <p className="signin-header">
              Sign In to PruXpress
            </p>
            <p className="signin-content">
              Prudential's PruXpress provides the resources you need to successfully expand your business
              with life insurance. It is designed so you can find what you need and get back to helping
              your clients.
            </p>


            <Box component="form" onSubmit={handleLogin}>

              {errorMessage !== undefined && (
                <label role="alert" htmlFor="txtloginsppwd" className="error">
                  {errorMessage}
                </label>
              )}
              <InputLabel className="labels form-group signin-block" htmlFor="username">User Name</InputLabel>
              <TextField
                margin="normal"
                fullWidth
                id="username"
                name="username"
                //size="small"
                autoComplete="username"
                className="formControl"
                inputRef={inputRef}
                value={userNametextfield}
                onChange={handleUserName}
                inputProps={{ maxLength: 32, "aria-describedby": "usernameError" }}


              />
              {userErrorMessage !== undefined && (
                <span id="usernameError" className="error">
                  {userErrorMessage}
                </span>
              )}
              <InputLabel className="labels form-group signin-block" htmlFor="password">Password</InputLabel>
              <TextField
                margin="normal"
                fullWidth
                name="password"
                inputRef={pwdRef}
                type="password"
                id="password"
                autoComplete="current-password"
                aria-describedby="passwordError"
                //size="small"
                className="formControl"
                value={passwordtextfield}
                onChange={handlePasswordChange}
                inputProps={{ maxLength: 32, "aria-describedby": "passwordError" }}



              />
              {pwdErrorMessage !== undefined && (
                <span id="passwordError" className="error"  >
                  {pwdErrorMessage}
                </span>
              )}
              <Box>
              <Button
                variant='contained'
                type="submit"
                fullWidth
                sx={{ ...styles.container.loginContainer.loginDiv.loginButton }}
                className="button_login"
              >
                Sign in
                <img src={loginsvg} alt="Login" />
              </Button>
              </Box>
            </Box>
            <Link to="#" onClick={(e) => {
              e.preventDefault();
              forgotlogincredentialsLink();
            }
            } className="forgotlogincredentials-link">Forgot  Username/Password
            </Link>
            <div className="register">
              <span className="not-login">
                Don't have a login?
              </span>
              <button className="registeration-button" onClick={registerNow} >
                <span className="register-now">Register now</span>
                <img src={loginsvg} alt="register" />
              </button>
            </div>
            <div className="faq">
              <p className="technical-help">Do you need technical help?</p>
              <ul className="list-items"><li className="list-faq">Brokerage Agency employees call 866-599-2871 and select option 1.</li></ul>
            </div>
          </div>
          <div className="form-right">
            <p className="right-content">
              <span className="right-content-one">
                When you're licensed and appointed to sell Prudential insurance policies,
              </span>
              <span className="right-content-two">Pruxpress is the place to:</span>
            </p>
            <p className="right-list">
              Get illustrations
            </p>
            <p className="right-list">
              Submit a new policy application
            </p>
            <p className="right-list">
              View pending case status
            </p>
            <p className="right-list">
              Find additional forms
            </p>
            <p className="right-list">
              Review underwriting requirements, niches, and criteria
            </p>
          </div>
        </div>
      </div>

    </div>
  );
};